import { render } from "./VersionControlSubComponent.vue?vue&type=template&id=172d01f8"
import script from "./VersionControlSubComponent.vue?vue&type=script&lang=js"
export * from "./VersionControlSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__